import {
  MachineCategoryBaseColumnTypes
} from '@constants/administration/portal-setup/machine-category/machine-category-base-column-types';

export class CategoryColumn {
  type?: MachineCategoryBaseColumnTypes;
  name: string = '';
  label: string = '';
  collapsed?: boolean = true;
  deletable: boolean = true;
  order: number = 0;
  sortable: boolean = false;
}
